/**
 * defa.views.UserSettingsPanel
 * A Panel for changing the common User Settings.
 * @version 1.2.3
 */
import View from 'scripts/poppet/view';
import template from 'templates/userSettingsPanel.jst.html'

const channelUser = Bb.Radio.channel( 'user' );

const selectors = {
	buttons   : '[data-click^=nav-]',
};

const UserSettingsPanel = View.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template         : template,
	className        : 'card user-panel',
	
	ui: {
		buttons: selectors.buttons,
	},
	
	events: {
		'click @ui.buttons': 'onClickButtons',
	},
	
	templateContext: function() {
		return {
			isMe          : this.isMe(),
			showUserRoles : this.showUserRoles(),
			userRoles     : this.createRolesHTML(),
		}
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
		 * Triggers when the view renders,
		 * TODO: Separate into each own cards.
		 * @void
		 */
	/*
		onRender: function() {
			
			let self = this;
			
			self.ui.email1.one( 'input', function(){
				self.ui.email2.parent().removeClass( 'hidden' ).addClass( 'fade-in' );
			});
			
			self.ui.email2.one( 'blur', function() {
				
				self.onChangeMail();
				
				self.ui.emails.on( 'input', function() {
					self.onChangeMail();
				});
			});
			
			let html5   = '',
			    numbers = this.phoneNumbers();
			
			if ( numbers ) {
				_.each( numbers, function( number ) {
					html5 += '<li>%s</li>'.replace( '%s', number.numberName() );
				});
			}
			
			this.ui.numbers.append( html5 );
		},
		*/
		
	/**
		 * Updates visual classes according to the email fields matching status.
		 * Separate into each own cards.
		 * @void
		 */
	/*
		onChangeMail: function() {
			this.doEmailFeedback();
		},
		*/
		
	// @ui events
	
	
	/**
		 * Triggers when the email button is clicked.
		 * @void
		 */
	onClickButtons: function( event ) {
		event.preventDefault();
		
		let id      = this.model.get( 'id' ),
			    $target = $( event.target ),
			    command = $target.attr( 'data-click' ).replace( 'nav-', '' );
			
		switch( command ) {
			
			case 'email' :
				this.trigger( 'nav', 'user:email', [ id, ] );
				break;
				
			case 'phone-numbers' :
				this.trigger( 'nav', 'phone:list', [ id, ] );
				break;
				
			case 'language' :
				this.trigger( 'nav', 'user:language', [ id, ] );
				break;
				
			case 'password' :
				this.trigger( 'nav', 'user:password', [ id, ] );
				break;
				
			case 'billing' :
				this.trigger( 'nav', 'customer:list', [ id, ] );
				break;
				
		}
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	
	// - helpers
	
	/**
		 * Show only customer roles for technical support.
		 * @return {bool} True if the current user has the role TECHNICAL_SUPPORT.
		 */
	showUserRoles: function() {
		return channelUser.request( 'model' ).hasRoles([ 'TECHNICAL_SUPPORT', ]);
	},
	
	/**
		 * Creates a list of roles for support to see.
		 * @return {string} Html-representation of the current customer model's roles array.
		 */
	createRolesHTML: function() {
		return this.model.get( 'transientRoles' ).join( ',<br>' );
	},
	
	/**
		 * Checks if the current model is me.
		 * @return {bool} True if the current model is me, false if not.
		 */
	isMe: function() {
		return ( this.model.get( 'id' ) === channelUser.request( 'id' ) );
	},
	
	/**
		 * Retrieves this user's phone numbers.
		 * @return {PhoneNumberCollection} A collection of PhoneNumbers or false if empty.
		 */
	/*
		phoneNumbers: function() {
			let phoneNumbers = channel.request( 'phoneNumbers' ).where({ user: this.model.get( 'id' ) });
			
			return ( phoneNumbers.length >= 1 ) ? phoneNumbers : false;
		},
		*/
		
		
	/**
		 * Adjusts feedback for matching emails
		 * @void
		 */
	/*
		doEmailFeedback: function() {
			
			let email1   = this.ui.email1,
			    email2   = this.ui.email2,
				feedback = this.ui.textEmail;
				
			if ( ! this.validateEmails() ) {
				this.disableSubmit();
				email1.addClass( 'error' );
				email2.addClass( 'error' );
				feedback
				    .removeClass( 'fade-out' )
					.removeClass( 'hidden' )
					.addClass( 'fade-in' );
			} else {
				this.enableSubmit();
				email1.removeClass( 'error' );
				email2.removeClass( 'error' );
				feedback
				    .removeClass( 'fade-in' )
					.addClass( 'fade-out' );
					
				setTimeout( function() {
					if ( feedback.hasClass( 'fade-out' ) ) {
						feedback.addClass( 'hidden' );
					}
				}, 1000 );
			}
		},
		*/
		
	/**
		 * Checks for matching emails
		 * @return {bool} True if the emails are matching, false if not.
		 */
	/*
		validateEmails: function() {
			let email1 = this.ui.email1.val().trim(),
			    email2 = this.ui.email2.val().trim();
			
			return ( email1 === email2 );
		},
		*/
		
	/**
		 * Validates the form
		 * @return {bool} True if the form validates, false if not.
		 */
	/*
		validate: function() {
			return this.validateEmails();
		},
		*/
		
	/**
		 * Triggers all feedback fields.
		 * @void
		 */
		 /*
		feedback: function() {
			this.doEmailFeedback();
		},
		*/
		
	/**
		 * Validates email-contacts and saves the data to the model.
		 * @void
		 */
		 /*
		submit: function() {
			
			this.model.saveEmail({
				email : this.ui.email1.val().trim(),
			});
		},
		*/
		
});
	
export default UserSettingsPanel;